import { TableBody, TableCell, TableColumn, TableHeader, TableRow } from './base';
import Table from './Table';

Table.Cell = TableCell;
Table.Column = TableColumn;
Table.Header = TableHeader;
Table.Row = TableRow;
Table.Body = TableBody;

export * from './Body';
export * from './Table';

export default Table;
